import React from 'react';
import { Tab, Form, Table, Search } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { State } from '../../../../../../common/types/state';
import { getContentExclusionTypeLabel } from '../../../enums/content-exclusion-type';
import {
    useContentExclusionsTableSearch,
} from '../../../group-modal/children/content-exclusions-tab/hooks/use-content-exclusions-table-search';
import './styles.scss';

const ContentExclusionsTabReadonly: React.FC = () => {
    const group = useSelector((state: State) => state.groups.singleGroup);

    const contentExclusions = group?.restriction?.contentExclusions || [];

    const {
        searchQuery,
        handleSearchChange,
        tableRows,
        hasExclusions,
        hasNoSearchResults,
    } = useContentExclusionsTableSearch(contentExclusions);

    const displayValue = (value: string) => value || '—';

    return (
        group &&
        <Tab.Pane>
            <div className="content-exclusions-tab-readonly">
                <Form>
                    <div className="content-exclusions-tab-readonly__search-row">
                        <Form.Field className="content-exclusions-tab-readonly__search-field">
                            <label>Search</label>
                            <Search
                                className="content-exclusions-tab-readonly__search"
                                placeholder="Search..."
                                onSearchChange={handleSearchChange}
                                results={[]}
                                value={searchQuery}
                                showNoResults={false}
                            />
                        </Form.Field>
                    </div>
                </Form>

                <div className="content-exclusions-tab-readonly__table-wrapper">
                    <Table celled className="content-exclusions-tab-readonly__table">
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Sport</Table.HeaderCell>
                                <Table.HeaderCell>Competition</Table.HeaderCell>
                                <Table.HeaderCell>Content Provider</Table.HeaderCell>
                                <Table.HeaderCell>Type</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {!hasExclusions ? (
                                <Table.Row>
                                    <Table.Cell colSpan={4} textAlign="center">
                                        No content exclusions configured
                                    </Table.Cell>
                                </Table.Row>
                            ) : hasNoSearchResults ? (
                                <Table.Row>
                                    <Table.Cell colSpan={4} textAlign="center">
                                        No exclusions match your search
                                    </Table.Cell>
                                </Table.Row>
                            ) : (
                                tableRows.map(({ exclusion, originalIndex }) => (
                                    <Table.Row
                                        key={
                                            exclusion.id != null
                                                ? exclusion.id
                                                : `exclusion-${originalIndex}`
                                        }
                                    >
                                        <Table.Cell>{displayValue(exclusion.sport)}</Table.Cell>
                                        <Table.Cell>{displayValue(exclusion.competition)}</Table.Cell>
                                        <Table.Cell>{displayValue(exclusion.dataProvider)}</Table.Cell>
                                        <Table.Cell>{getContentExclusionTypeLabel(exclusion.type)}</Table.Cell>
                                    </Table.Row>
                                ))
                            )}
                        </Table.Body>
                    </Table>
                </div>
            </div>
        </Tab.Pane>
    );
};

export default ContentExclusionsTabReadonly;
